/**
 * Convierte un valor con formato de moneda (símbolo $, puntos de miles, coma decimal)
 * a un número entero, eliminando caracteres no numéricos.
 * Inverso de formatterMoney.
 * @param {string|number|null} valorFormateado - Valor formateado (ej: "$ 1.234.567")
 * @returns {number} Número entero (ej: 1234567) o 0 si es vacío/null.
 */
export const parsearMoneda = (valorFormateado) => {
  if (!valorFormateado) return 0;
  const valorSinFormato = String(valorFormateado).replace(/[^0-9]/g, '');
  return Number.parseInt(valorSinFormato, 10) || 0;
};

/**
 * Aplica formato de moneda a un valor (con símbolo $ y decimales)
 * @param {string|number} valor Valor a formatear
 * @param {number} decimales Cantidad de decimales a mostrar
 * @returns {string} Valor formateado como moneda
 */
export const formatterMoney = (valor, decimales = 2) => {
  const valorFormateado = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: decimales,
    maximumFractionDigits: decimales,
  });
  return valorFormateado.format(valor);
};

/**
 * Aplica formato numérico (miles) sin símbolo de moneda.
 * Útil para inputs con prefix="$ " donde el $ lo pone el componente.
 * @param {string|number} valor Valor a formatear
 * @returns {string} Número formateado con separador de miles
 */
export const formatearNumero = (valor) => {
  if (valor === null || valor === '') return '';
  const num = Number(valor);
  return Number.isNaN(num) ? String(valor) : new Intl.NumberFormat('es-CO').format(num);
};
